import { useTranslation } from '@hopin-team/provider-translation';
import cx from 'classnames';
import React from 'react';

import { ColorPreview } from './color-preview';

type ThemeCardProps = {
  className?: string;
  name: string;
  primary?: string;
  background?: string;
  text?: string;
  isDefault: boolean;
  isFlagged?: boolean;
};

export const ThemeCard = ({
  className,
  name,
  primary,
  background,
  text,
  isDefault,
}: ThemeCardProps) => {
  const { t } = useTranslation();
  return (
    <div className={cx(className, 'flex w-full flex-col')}>
      <div className="flex justify-between text-left text-sm font-medium">
        <div>
          {name}
          {isDefault && (
            <span className="ml-1 text-gray-400">
              {t('content-recording.appearance.color-presets.default')}
            </span>
          )}
        </div>
      </div>

      <div className="ml-1 mt-1 flex gap-2">
        <ColorPreview backgroundColor={primary} size="small" />
        <ColorPreview backgroundColor={background} size="small" />
        <ColorPreview backgroundColor={text} size="small" />
      </div>
    </div>
  );
};
